var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"box_img"},[_c('el-col',{attrs:{"span":24}},[_c('img',{staticClass:"img_left",attrs:{"src":require("../../static/mac_left.png"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"img_right",attrs:{"src":require("../../static/info_right.png"),"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abb1e47a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Footer.vue
// module id = null
// module chunks = 